import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import PageGray from '../../../components/General/PageGray';
import H1 from '../../../components/Typography/Headings/H1';
import { useTranslation } from 'react-i18next';
import Span from '../../../components/Typography/Span';
import MainStats from '../../../components/Stats/MainStats/MainStats';
import Diagnosis from '../../../components/Stats/Diagnosis';
import { useGetStats } from '../../../hooks/profile/useStats';
import Loader from '../../../components/Loader/Loader';
import GeneralError from '../../../components/Errors/General';
import P from '../../../components/Typography/P';
import { useAuth } from '../../../auth/AuthContext';
import { pushGtmEvent } from '../../../lib/gtm';
import { getPreviousPathname } from '../../../lib/previousRoute';

export const Route = createFileRoute('/_sidebar/statistiche/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { brandStats: stats, isFetching, error } = useGetStats();
  const { t } = useTranslation();
  const { user } = useAuth();

  useEffect(() => {
    pushGtmEvent({
      event: 'statistiche_page_view',
      user_id: user?.profile.sub,
      previous_page: getPreviousPathname(),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return <GeneralError />
  }

  if (!stats?.overall && !isFetching) {
    return (
      <div className="w-full flex flex-col items-center justify-center mt-9 gap-6">
        <img
          src="/illustrations/bad-score.svg"
          alt="No stats"
          width={150}
        />
        <Span className="font-bold text-2xl!">{t('stats.noStats')}</Span>
        <P>{t('stats.noStatsDesc')}</P>
      </div>
    );
  }

  return (
    <PageGray className="flex flex-col gap-8">
      <div className="flex flex-col gap-4">
        <H1>{t('profileDropdown.progress')}</H1>
        <Span>{t('stats.subtitle')}</Span>
      </div>
      {isFetching ? (
        <div className="flex justify-center w-full">
          <Loader />
        </div>
      ) : (
        <>
          <Diagnosis />
          <MainStats stats={stats} />
        </>
      )}
    </PageGray>
  );
}
